export interface U2102LoadLogicalUnitActionHandlersParams<T = any> {
  doLoadLogicalUnitFn: () => Promise<any>;
  onSuccess?: (rows: T[]) => void;
  onError?: (errors: { error: any }) => void;
}

export interface U2102LoadLogicalUnitActionHandlersReturn {
  loadLogicalUnitActions: () => void;
}

export function useU2102LoadLogicalUnitActionHandlers<T extends { id: string } = any>({
  doLoadLogicalUnitFn,
  onSuccess,
  onError,
}: U2102LoadLogicalUnitActionHandlersParams<T>): U2102LoadLogicalUnitActionHandlersReturn {
  const loadLogicalUnitActions = async () => {
    try {
      const response = await doLoadLogicalUnitFn();
      const rows: T[] = response.data.results as unknown as T[];

      if (onSuccess) {
        onSuccess(rows);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { loadLogicalUnitActions };
}
